import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FlowStatusService } from 'src/app/invopay/services/flow-status.service';
import { IpLicenceService } from 'src/app/invopay/services/ip-licence.service';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';

@Component({
  selector: 'app-fn-my-finance',
  templateUrl: './fn-my-finance.component.html',
  styleUrls: ['./fn-my-finance.component.scss'],
})
export class FnMyFinanceComponent implements OnInit, OnDestroy {
  isLoaded: boolean = false;
  type!: 'business' | 'employee' | 'provider';
  showTabs: boolean = false;
  subscriptions: Subscription[] = [];
  selectedSupplierId?: number;
  businessName?: string;

  constructor(
    private ipRoleService: IpRoleService,
    private ipLicenceService: IpLicenceService,
    private flowStatusService: FlowStatusService,
    private ipSnackbarService: IpSnackbarService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const supplierId = params.get('supplierId');
      const businessName = params.get('businessName');
      if (supplierId && supplierId.trim() !== '') {
        this.selectedSupplierId = Number(supplierId);
      }
      if (businessName && businessName.trim() !== '') {
        this.businessName = businessName;
      }
      this.isLoaded = true;
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  changeType() {}
}
